module.exports = __webpack_public_path__ + "img/cajaChicasTalca.06cdad67.svg";